"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Ganymede = undefined;

var _ice = require("ice");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Ganymede/Ganymede.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

let Ganymede = _ModuleRegistry.module("Ganymede");

Object.defineProperty(Ganymede, 'AccessTokenContextKey', {
    value: "accessToken"
});
exports.Ganymede = Ganymede;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/Ganymede/Ganymede.js
// module id = 465
// module chunks = 0